<script>
    import { createEventDispatcher } from 'svelte'
    import { fade }                  from 'svelte/transition'

    export let   accept   = ".*"
    export let   reader   = (r, file) => r.readAsDataURL(file)
           let   fp       = null
           let   file     = null
           const dispatch = createEventDispatcher()

    function start(e) {
        e.preventDefault()
        fp.click() 
    }

    function readfiles() {
        file = fp.files[0]
        if(file) {
            const r = new FileReader()
            r.addEventListener('load', event => { 
                dispatch('change', { file, value: event.target.result })
            })
            reader(r, file)
        } else {
            dispatch('change', { file: null, value: null })
        }
    }

    function removeFile() {
        file = null
        dispatch('change', { file: null, value: null })
    }

</script>
<div class="container">
    <input type="file" bind:this={fp} on:change={readfiles} accept={accept}/>
    <button class="ui blue left labeled icon button"
            on:click={ start }>
        <i class="upload icon"></i>Arquivo
    </button>
    {#if file}
        <span class="ui label" transition:fade>{file.name}<i class="close icon" on:click={removeFile}></i></span>
    {/if}
</div>
<style>
    .container input[type="file"] {
        display: none;
    }
</style>

